import * as React from 'react';
import '../../styles/components/swatch.scss';

export interface SwatchProps {
    title: string;
    value: string;
    index?: number;
    //Whenever the swatch is part of a group
    group: string;
    selected?: boolean;
    available: boolean;
    swatchImage?: string | null;
    href?: string;
    onSwatchSelected?: (value: string) => void
}

const Swatch = (props: SwatchProps) => {
  const {selected, available, title, value, index, group, onSwatchSelected} = props;
  const fieldName = `group${ group.charAt(0).toUpperCase() + group.substring(1).replace(' ','') }`;
  const id = fieldName + title.replace(' ','');
  const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      if (available && onSwatchSelected) {
        onSwatchSelected(value);
      }
  };
  return (
    <div tabIndex={-1} className={ 'swatch' + (selected === true ? ' selected' : '') + (available === true ? ' available' : ' out-of-stock') }>
      <input key={`input${id}${index}`} tabIndex={ available ? 0 : -1 } id={id} disabled={!available} type="radio" name={ fieldName } value={ value } onChange={ handleChange }/>
      <label tabIndex={-1} htmlFor={id} className="swatch__label">
        { title }
      </label>
    </div>
  );
}
export default Swatch;
